import groupBy from 'lodash.groupby'

const _createItemObject = (item: ListItemV2) => ({
  ...item,
  vertical: {
    id: item.vertical?.id,
    name: item.vertical?.key,
  },
})

export const getGroupedItems = (items: any[]) => {
  const group = groupBy(items, 'group_id')
  const groupedItems: any[] = []
  const groupsAdded: number[] = []

  // Iterating through original `items` to maintain the order
  items.forEach(item => {
    const groupId = item.group_id
    if (groupId && groupsAdded.includes(groupId)) return
    const itemsInGroup = group[groupId]
    const isPrivateDoc = groupId === null
    const isOnlyItemInGroup = itemsInGroup.length === 1
    const type = isOnlyItemInGroup || isPrivateDoc ? 'assignment' : 'group'

    groupedItems.push({
      type,
      assignments: isPrivateDoc
        ? [_createItemObject(item)]
        : itemsInGroup.map(groupItem => _createItemObject(groupItem)),
      group: {
        id: groupId,
        item_count: isPrivateDoc ? 1 : itemsInGroup.length,
      },
    })
    groupsAdded.push(groupId)
  })

  return groupedItems
}
